export default function FooterCta() {
  return (
    <footer className="py-20 bg-gradient-to-b from-black to-purple-950/30">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            まずはお気軽にLINEで無料相談
          </h2>
          <p className="text-xl text-gray-300 mb-10">
            プロのデザイナーがあなたのご要望をお伺いします
          </p>
          <a
            href="https://line.me/R/ti/p/@ula6319m?oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-[#06C755] hover:bg-[#05b34c] text-white text-xl font-bold px-12 py-5 rounded-full shadow-2xl transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-3xl"></i>
            今すぐLINEで友達追加
          </a>
        </div>

        <div className="border-t border-purple-500/20 pt-8 mt-12">
          <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-400 text-sm">
            <a
              href="http://tempo-testserver.com/lp/lp/privacy/"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-yellow-400 transition-colors duration-300 cursor-pointer whitespace-nowrap"
            >
              プライバシーポリシー/特定商取引法に基づく表記
            </a>
          </div>
          <div className="text-center mt-6 text-gray-500 text-sm">
            © 2024 オリシャン. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
}